import { render, staticRenderFns } from "./SegmentChart.vue?vue&type=template&id=4eb5f146&scoped=true"
import script from "./SegmentChart.vue?vue&type=script&lang=js"
export * from "./SegmentChart.vue?vue&type=script&lang=js"
import style0 from "./SegmentChart.vue?vue&type=style&index=0&id=4eb5f146&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eb5f146",
  null
  
)

export default component.exports